export default "__VITE_ASSET__C7Zg1Dxd__"